module.exports = __webpack_public_path__ + "static/media/tadalafil-10mg.454d24a0.png";